import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import { notification, Collapse, Modal } from 'antd';
import Button from '../../components/Button/Button';
import Place from '../../assets/icons/Place';
import picture from '../../assets/images/instructor.svg';
import { learnSubject } from '../../dummyData';
import { EditorState } from 'draft-js';

import Article from '../../assets/icons/Article';
import Timer from '../../assets/icons/Timer';
import DateRange from '../../assets/icons/DateRange';
import Students from '../../assets/icons/Students';
import WoodenChair from '../../assets/icons/WoodenChair';
import moment from 'moment';
import ReactPlayer from 'react-player/lazy';
import Spinner from '../../components/Spinner/Spinner';
import { deleteContent } from '../../services/learnService';
import Delete from '../../assets/icons/Delete';
import { baseURL } from '../../utils/axios';

import TakeQuiz from '../../components/TakeQuiz/TakeQuiz';
import Edit from '../../assets/icons/Edit';
import DeleteNew from '../../assets/icons/DeleteNew';
import EditContentModal from '../../components/EditContentModal/EditContentModal';
import UpdateVideo from '../EditPages/UpdateVideo';
import UpdateAudio from '../EditPages/UpdateAudio';
import UpdateImage from '../EditPages/UpdateImage';
import UpdateDoc from '../EditPages/UpdateDoc';
import UpdateText from '../EditPages/UpdateText';
import EditLessonModal from '../../components/EditLessonModal/EditLessonModal';

const SingleLesson = () => {
  const { Panel } = Collapse;
  let teacher = JSON.parse(localStorage.getItem('userData'));
  const urlParams = new URLSearchParams(window.location.search);
  const edit = urlParams.get('edit');

  const { id } = useParams();
  const navigate = useNavigate();

  const [content, setContent] = useState({});
  const [visible, setVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editLessonVisible, setEditLessonVisible] = useState(false);
  const [singleLesson, setSingleLesson] = useState('');
  const [loading, setLoading] = useState(false);
  const [playLoading, setPlayLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [setEditorState] = useState(EditorState.createEmpty());

  const [, setUnits] = useState(0);
  const [lessons, setLessons] = useState(0);
  const [lessonId, setLessonId] = useState('');
  const [selectedContent, setSelectedContent] = useState({});
  const [selectedLessonId, setSelectedLessonId] = useState({});

  const closeEdit = () => {
    setEditVisible(false);
    setEditLessonVisible(false);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const getSingleCourse = async () => {
    let token = localStorage.getItem('token');
    let teacher = JSON.parse(localStorage.getItem('userData'));
    setLoading(true);
    const res = await fetch(`${baseURL}/teachers/${teacher.id}/topics/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
    });
    const data = await res.json();

    if (res.status === 200) {
      if (data.message === 'No record found') {
        navigate('/tutor/courses');
      } else {
        setContent(data?.data?.topic);
        if (data?.data?.topic?.lessons[0]?.contents[0]?.type === 'video') {
          setPlayLoading(true);
        } else {
          setPlayLoading(false);
        }
        setSelectedContent(data?.data?.topic?.lessons[0]?.contents[0]);
      }
    } else {
      setContent(learnSubject);
    }

    if (res.status === 401) {
      notification['error']({
        message: 'Session expired, please log in again',
      });
      navigate('/login');
    }
    setLoading(false);
  };
  useEffect(() => {
    getSingleCourse();
  }, []);

  const setCurrentContent = (item) => {
    if (item.type === 'video') {
      setPlayLoading(true);
    } else {
      setPlayLoading(false);
    }
    setSelectedContent(item);
  };

  const deleteSelectedContent = async () => {
    try {
      setDeleteLoading(true);
      let res = await deleteContent(
        content.course.id,
        id,
        selectedLessonId,
        selectedContent.id
      );

      notification['success']({
        message: 'Content Deleted Successfully',
      });
      setDeleteLoading(false);
      handleCancel();
      getSingleCourse();
    } catch (error) {
      setDeleteLoading(false);
      notification['error']({
        message: error.response.data.message || 'Unable to delete',
      });
    }
  };

  const onChange = (key) => {
    setSelectedLessonId(key);
  };

  return (
    <>
      <Helmet>
        <title>PL by Edves | Preview</title>
      </Helmet>
      <DashboardHeader />

      {loading ? (
        <Spinner />
      ) : (
        <div className='takecourse'>
          <div className='takecourse__breadcrumbs'>
            <span onClick={() => navigate('/tutor-dashboard')}>
              <svg
                width='18'
                height='12'
                viewBox='0 0 18 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
                  fill='#161410'
                />
              </svg>
            </span>
            <p>
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/tutor-dashboard')}
              >
                {' '}
                Home
              </span>{' '}
              | <span onClick={() => navigate('/tutor/courses')}>
                Lessons
              </span>{' '}
              | {content?.title}
            </p>
          </div>
          <div className='takecourse__body'>
            <div className='takecourse__body__course-details'>
              <div className='takecourse__body__course-details__section'>
                {playLoading && <Spinner />}
                {selectedContent?.type === 'image' ? (
                  <img src={selectedContent.location} alt='' />
                ) : selectedContent?.type === 'video' ? (
                  <ReactPlayer
                    url={selectedContent.location}
                    controls
                    width='100%'
                    height='100%'
                    fallback={<Spinner />}
                    onReady={(prev) => {
                      setPlayLoading(!prev?.player?.isReady);
                    }}
                  />
                ) : // <ReactPlayer
                //   url={selectedContent.location}
                //   controls
                //   width='100%'
                //   height='100%'
                // />
                selectedContent?.type === 'text' ? (
                  <div className='render-text'>
                    {selectedContent.description}
                  </div>
                ) : selectedContent?.type === 'doc' ? (
                  <iframe
                    width='100%'
                    title={`title-${Math.random()}`}
                    height={'100%'}
                    src={selectedContent.location}
                  ></iframe>
                ) : selectedContent?.type === 'audio' ? (
                  <div
                    className='audio-placeholder'
                    style={{ backgroundImage: `url(${teacher?.school?.logo})` }}
                  >
                    <audio controls>
                      <source src={selectedContent.location} type='audio/ogg' />
                      <source
                        src={selectedContent.location}
                        type='audio/mpeg'
                      />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                ) : selectedContent?.type === 'quiz' ? (
                  <TakeQuiz title={selectedContent?.title} />
                ) : (
                  <div></div>
                )}
              </div>
              <div className='single-lesson-details'>
                <div className=' single-lesson-details__heading'>
                  <div className='single-lesson-details__heading__icon'>
                    <Article />
                  </div>

                  <h3>Lesson Details</h3>
                </div>
                <div className='single-lesson-details__children'>
                  <div className='single-lesson-details__body'>
                    <div className='single-lesson-details__body__icon'>
                      <Timer />
                    </div>
                    <div className='single-lesson-details__body__text'>
                      <p>Duration</p>
                      <p>{content?.course?.duration}</p>
                    </div>
                  </div>

                  <div className='single-lesson-details__body'>
                    <div className='single-lesson-details__body__icon'>
                      <DateRange />
                    </div>
                    <div className='single-lesson-details__body__text'>
                      <p>Published</p>
                      <p>
                        {content?.course?.published_at
                          ? moment(content?.course?.published_at).format('lll')
                          : 'Not published yet'}
                      </p>
                    </div>
                  </div>

                  <div className='single-lesson-details__body'>
                    <div className='single-lesson-details__body__icon'>
                      <Students />
                    </div>
                    <div className='single-lesson-details__body__text'>
                      <p>Students</p>
                      <p>{content?.course?.students_count} Enrolled</p>
                    </div>
                  </div>

                  <div className='single-lesson-details__body'>
                    <div className='single-lesson-details__body__icon'>
                      <WoodenChair />
                    </div>
                    <div className='single-lesson-details__body__text'>
                      <p>Class</p>
                      <p>{content?.course?.subject_class?.title}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='takecourse__body__about'>
                <h3>
                  {content.title}{' '}
                  <span
                    className={
                      content?.course?.published
                        ? 'published-tag'
                        : 'unpublished-tag'
                    }
                  >
                    {content?.course?.published ? 'Published' : 'Not Published'}
                  </span>
                </h3>
                <p>{content?.description}</p>

                {/* <p className='learn-about__more'>
                Show More
                <svg
                  width='8'
                  height='6'
                  viewBox='0 0 8 6'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8 1.66656L7.06 0.726563L4 3.7799L0.94 0.726563L0 1.66656L4 5.66656L8 1.66656Z'
                    fill='#FEA82F'
                  />
                </svg>
              </p> */}
              </div>

              <div className='takecourse__body__about'>
                <h3>What you’ll learn</h3>
                <div className='learn-about__what-you-will-learn'>
                  {content?.course?.learning_outcomes.map((el) => (
                    <div
                      className='learn-about__flex-item'
                      key={Math.random(1000)}
                    >
                      <div className='learn-about__flex-item__circle'>
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z'
                            fill='#161410'
                          />
                        </svg>
                      </div>
                      <p>{el.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className='takecourse__body__about'>
                <h3>Live class schedule (Group class)</h3>
                {content?.course?.live_classes.map((el) => (
                  <div className='single-course-live'>
                    <div className='single-course-live__item'>
                      <div className='blue-dot'></div>
                      <div className='single-course-live__item__content'>
                        <p className='single-course-live__item__content__title'>
                          {el?.learning_focus}
                        </p>
                        <div className='single-course-live__item__content__timing'>
                          <p>{moment(el?.start_date)?.format('lll')}</p>
                          <svg
                            width='4'
                            height='4'
                            viewBox='0 0 4 4'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <circle cx='2' cy='2' r='2' fill='#D5D4D4' />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className='takecourse__body__help'>
                <h3>Instructor</h3>
                <div className='takecourse__body__help__flex'>
                  <div className='takecourse__body__help__flex__logo'>
                    <img
                      src={content?.course?.school?.logo || picture}
                      alt={content?.course?.school?.name}
                    />
                  </div>
                  <div className='takecourse__body__help__flex__tutor'>
                    <h4>{content?.course?.school?.name} </h4>
                    <div>
                      <Place />

                      <p style={{ margin: '0' }}>
                        {`${content?.course?.school?.state}, Nigeria`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='takecourse__body__subject-content'>
              <h3>Subject Content</h3>

              <Collapse
                expandIconPosition={'right'}
                onChange={onChange}
                accordion
              >
                {content?.lessons?.map((el, id) => (
                  <Panel
                    className='takecourse__body__subject-content__collapse-header'
                    header={
                      <div>
                        <div className='takecourse__body__subject-content__heading'>
                          {' '}
                          <span
                            style={{ marginRight: '10px', color: '#5A5955' }}
                          >
                            <h4> {`${el.sn}.0`}</h4>
                          </span>
                          <span>
                            <h4> {el.title}</h4>
                          </span>
                          <button
                            style={{ all: 'unset' }}
                            onClick={() => {
                              setEditLessonVisible(true);
                              setLessonId(el.id);
                              setSingleLesson({
                                sn: el.sn,
                                title: el.title,
                              });
                            }}
                          >
                            {edit === 'true' && (
                              <span
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '18px',
                                }}
                              >
                                <Edit />
                              </span>
                            )}
                          </button>
                        </div>
                        <div className='takecourse__body__subject-content__subheading'>
                          <p>
                            Estimated Duration | {content?.lessons?.length * 13}{' '}
                            mins
                          </p>
                        </div>
                      </div>
                    }
                    key={el.id}
                  >
                    {el.contents.map((item, idx) => (
                      <div
                        className={
                          selectedContent?.id === item?.id
                            ? 'active-sub-wrapper'
                            : 'sub-wrapper'
                        }
                      >
                        <div className='content__topics__sub'>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <div
                              style={{
                                marginTop: '15px',
                                display: 'flex',
                                gap: '5px',
                              }}
                            >
                              <div
                                style={{
                                  marginTop: '3px',
                                  display: 'flex',
                                  gap: '5px',
                                }}
                              >
                                <svg
                                  width='14'
                                  height='12'
                                  viewBox='0 0 14 12'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M11.7768 0H1.79339C1.00898 0 0.367188 0.6 0.367188 1.33333V10.6667C0.367188 11.4 1.00898 12 1.79339 12H11.7768C12.5612 12 13.203 11.4 13.203 10.6667V1.33333C13.203 0.6 12.5612 0 11.7768 0ZM11.7768 10.6667H1.79339V1.33333H11.7768V10.6667ZM11.0566 4L10.0511 3.05333L5.35176 7.44667L3.51196 5.73333L2.49936 6.67333L5.35176 9.33333L11.0566 4Z'
                                    fill='#FEA82F'
                                  />
                                </svg>
                              </div>

                              <div>
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: '17px',
                                    flexDirection: 'column',
                                  }}
                                  onClick={() => {
                                    setUnits(id);
                                    setLessons(0);
                                  }}
                                >
                                  <p
                                    style={{
                                      fontWeight: 700,
                                      maxWidth: '180px',
                                    }}
                                    onClick={() => {
                                      setCurrentContent(item);
                                    }}
                                  >
                                    {`${el.sn}.${idx + 1}`}{' '}
                                    <span
                                      style={{
                                        color: '#161410',
                                      }}
                                    >
                                      {item.title}
                                    </span>
                                  </p>
                                </div>

                                <p
                                  style={{
                                    fontWeight: 300,
                                    fontSize: '12px !important',
                                  }}
                                >
                                  {item.type === 'video' ? (
                                    <svg
                                      width='14'
                                      height='14'
                                      viewBox='0 0 14 14'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <path
                                        d='M5.66634 9.99992L9.66634 6.99992L5.66634 3.99992V9.99992ZM6.99967 0.333252C3.31967 0.333252 0.333008 3.31992 0.333008 6.99992C0.333008 10.6799 3.31967 13.6666 6.99967 13.6666C10.6797 13.6666 13.6663 10.6799 13.6663 6.99992C13.6663 3.31992 10.6797 0.333252 6.99967 0.333252ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.93992 1.66634 6.99992C1.66634 4.05992 4.05967 1.66659 6.99967 1.66659C9.93967 1.66659 12.333 4.05992 12.333 6.99992C12.333 9.93992 9.93967 12.3333 6.99967 12.3333Z'
                                        fill='#161410'
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      width='12'
                                      height='12'
                                      viewBox='0 0 12 12'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <path
                                        d='M7.44667 1.33333L10.6667 4.55333V10.6667H1.33333V1.33333H7.44667ZM7.44667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V4.55333C12 4.2 11.86 3.86 11.6067 3.61333L8.38667 0.393333C8.14 0.14 7.8 0 7.44667 0ZM2.66667 8H9.33333V9.33333H2.66667V8ZM2.66667 5.33333H9.33333V6.66667H2.66667V5.33333ZM2.66667 2.66667H7.33333V4H2.66667V2.66667Z'
                                        fill='#161410'
                                      />
                                    </svg>
                                  )}{' '}
                                  {item.type}
                                </p>
                              </div>
                            </div>

                            {edit === 'true' && (
                              <div className='edit-actions'>
                                <div
                                  onClick={() => {
                                    setEditVisible(true);
                                    setCurrentContent(item);
                                    setLessonId(el.id);
                                  }}
                                >
                                  <Edit />
                                </div>
                                <div
                                  onClick={() => {
                                    setVisible(true);
                                    setCurrentContent(item);
                                    setLessonId(el.id);
                                  }}
                                >
                                  <DeleteNew />
                                </div>
                              </div>
                            )}
                            {/* 
                            <Popover
                              content={
                                <div className='popover-item'>
                                  <p
                                    onClick={() => {
                                      setVisible(true);
                                      setCurrentContent(item);
                                    }}
                                  >
                                    {deleteLoading ? (
                                      'Deleting...'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          gap: '10px',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Delete />
                                        <p style={{ color: '#F71E1E' }}>
                                          Delete Content
                                        </p>
                                      </div>
                                    )}
                                  </p>
                                </div>
                              }
                              trigger='click'
                              open={open}
                              onOpenChange={handleOpenChange}
                            >
                              <div
                                className='card-popover'
                                style={{
                                  marginTop: '0',
                                  justifySelf: 'flex-end',
                                }}
                              >
                                <svg
                                  width='4'
                                  height='12'
                                  viewBox='0 0 4 12'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M2.00033 3.33335C2.73366 3.33335 3.33366 2.73335 3.33366 2.00002C3.33366 1.26669 2.73366 0.666687 2.00033 0.666687C1.26699 0.666687 0.666992 1.26669 0.666992 2.00002C0.666992 2.73335 1.26699 3.33335 2.00033 3.33335ZM2.00033 4.66669C1.26699 4.66669 0.666992 5.26669 0.666992 6.00002C0.666992 6.73335 1.26699 7.33335 2.00033 7.33335C2.73366 7.33335 3.33366 6.73335 3.33366 6.00002C3.33366 5.26669 2.73366 4.66669 2.00033 4.66669ZM2.00033 8.66669C1.26699 8.66669 0.666992 9.26669 0.666992 10C0.666992 10.7334 1.26699 11.3334 2.00033 11.3334C2.73366 11.3334 3.33366 10.7334 3.33366 10C3.33366 9.26669 2.73366 8.66669 2.00033 8.66669Z'
                                    fill='#5A5955'
                                  />
                                </svg>
                              </div>
                            </Popover> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </Panel>
                ))}
              </Collapse>
            </div>
          </div>
        </div>
      )}

      <Modal
        width={606}
        visible={visible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Delete />
            </div>
            <h2>Delete Content Upload?</h2>
            <p style={{ marginBottom: '32px' }}>
              Are you sure you want to delete this upload
            </p>
            <Button
              text={deleteLoading ? 'deleting...' : 'Yes'}
              className='w-full'
              onClick={() => deleteSelectedContent()}
            />
            <p style={{ marginTop: '32px' }} onClick={() => handleCancel()}>
              Cancel
            </p>
          </div>
        </div>
      </Modal>
      <EditContentModal
        visible={editVisible}
        handleCancel={closeEdit}
        title='Edit Content'
        callback={getSingleCourse}
        footer={selectedContent?.type !== 'text'}
      >
        {selectedContent?.type === 'audio' && (
          <UpdateAudio
            selectedContent={selectedContent}
            schoolId={content?.course?.school?.id}
            courseId={content?.course?.id}
            topicId={id}
            lessonId={lessonId}
          />
        )}
        {selectedContent?.type === 'video' && (
          <UpdateVideo
            selectedContent={selectedContent}
            schoolId={content?.course?.school?.id}
            courseId={content?.course?.id}
            topicId={id}
            lessonId={lessonId}
          />
        )}

        {selectedContent?.type === 'image' && (
          <UpdateImage
            selectedContent={selectedContent}
            schoolId={content?.course?.school?.id}
            courseId={content?.course?.id}
            topicId={id}
            lessonId={lessonId}
          />
        )}
        {selectedContent?.type === 'doc' && (
          <UpdateDoc
            selectedContent={selectedContent}
            schoolId={content?.course?.school?.id}
            courseId={content?.course?.id}
            topicId={id}
            lessonId={lessonId}
          />
        )}

        {selectedContent?.type === 'text' && (
          <UpdateText
            selectedContent={selectedContent}
            schoolId={content?.course?.school?.id}
            courseId={content?.course?.id}
            topicId={id}
            lessonId={lessonId}
            close={closeEdit}
          />
        )}
      </EditContentModal>

      <EditLessonModal
        singleLesson={singleLesson}
        visible={editLessonVisible}
        handleCancel={closeEdit}
        title='Edit Lesson'
        callback={getSingleCourse}
        schoolId={content?.course?.school?.id}
        courseId={content?.course?.id}
        topicId={id}
        lessonId={lessonId}
      />
    </>
  );
};

export default SingleLesson;
